const projects = [
  {
    id: 0,
    name: 'Houston Guide',
    link: 'https://houston.drewford.dev',
    github: 'https://github.com/SleazyCook/houston',
    tag: 'Solo · Fullstack',
    blurb: "My own guide to all my favorite places in Houston, Texas — restaurants, bars, bookstores, coffee shops, music venues, parks, hidden photo spots, and more. Explore by neighborhood, map, or list.",
    highlights: ['Interactive Leaflet Map', 'List View', 'Neighborhood View'],
    stack: ['React', 'HTML5', 'CSS3', 'Firebase', 'Git', 'Netlify'],
    img: 'https://i.imgur.com/bSTXzmH.png',
  },
  {
    id: 1,
    name: 'Metro Houston',
    link: 'https://metro.drewford.dev',
    github: 'https://github.com/DevelopedByDrewford/transit',
    tag: 'Solo · React',
    blurb: "Real-time departure tracking for Houston's Metro Red Line — find upcoming trains at the nearest stop or any of your favorited stations, all in a clean, minimal interface built for daily commuters.",
    highlights: ['Real-time Tracking', 'Favorite Stations', 'Clean UX/UI'],
    stack: ['React', 'HTML5', 'CSS3', 'Git', 'Netlify'],
    img: 'https://i.imgur.com/J2XqitS.png',
  },
  {
    id: 2,
    name: 'D&D Adventure Guide',
    link: 'https://sunseekers.drewford.dev',
    github: 'https://github.com/SleazyCook/sunseekers',
    tag: 'Solo · React',
    blurb: "A detailed, wiki-like resource for our long-running D&D campaign — lore, maps, character backstories, and interactive elements that keep players immersed as the adventure unfolds.",
    highlights: ['Wiki-style Pages', 'Interactive Map', 'Interactive Tarot Reading'],
    stack: ['React', 'HTML5', 'CSS3', 'Sass', 'Git', 'Netlify'],
    video: 'https://www.youtube.com/embed/q8hclLdrzVM?si=0aERwZaIPsNFuP1X',
  },
  {
    id: 3,
    name: 'Streaming App Clone',
    link: 'https://watch-marathon.netlify.app',
    github: 'https://github.com/orgs/React-Royalty/repositories?',
    tag: 'Group · Full Stack',
    blurb: "A team-built clone of a streaming platform with original design choices. We built the entire back end from scratch, created a custom data set, and shipped a fully homegrown system end-to-end.",
    highlights: ['Stunning Front End', 'Authentication', 'Hashmap Database'],
    stack: ['JavaScript', 'HTML5', 'PostgreSQL', 'Node.js', 'React', 'Sass', 'Netlify', 'Render'],
    img: 'https://i.imgur.com/YieIROC.png',
  },
  {
    id: 4,
    name: 'Choose Your Own Adventure',
    link: 'https://death-house.netlify.app',
    github: 'https://github.com/SleazyCook/Durst-Manor',
    tag: 'Solo · Vanilla JS',
    blurb: "A choose-your-own-adventure game based on a real D&D session. Visual cards for each scenario, an illustrated inventory, and multiple endings — every decision can lead somewhere heroic or tragically gruesome.",
    highlights: ['Horror-themed Adventure', 'Inventory Display', 'Multiple Endings'],
    stack: ['HTML5', 'JavaScript', 'CSS3'],
    img: 'https://i.imgur.com/CXaurXy.png',
  },
  {
    id: 5,
    name: 'Sudoku',
    link: 'https://sudoku-slam.netlify.app',
    github: 'https://github.com/Website-Slammers/SudokuBackend',
    tag: 'Group · Full Stack',
    blurb: "A full-stack Sudoku game with a focus on a relaxing front-end. Intuitive gameplay, a calming interface, and a custom back end for smooth performance.",
    highlights: ['Beautiful Front End', 'Functional Game', 'Relaxing'],
    stack: ['React', 'Node.js', 'JavaScript', 'HTML5', 'CSS3', 'Netlify'],
    img: 'https://i.imgur.com/IhPkkTS.png',
  },
];

export default projects;
